import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { initializeAuth } from './store/authSlice';
import App from './App';
import './index.css';

// Restore any existing Cognito session before the app renders.
// On the callback path, the CallbackPage handles auth setup.
// On all other paths, read tokens from localStorage (fast) or fall back to Amplify.
if (!window.location.pathname.startsWith('/callback')) {
  store.dispatch(initializeAuth());
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
